import { DashboardHelper } from '../../../../../services/dashboard.service';
import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { BaseComponent } from '../../../../base/base.component';
import * as AppConstants from '../../../../../modules/catch-core/data/constants/app.constants';
import { ReportBottomToolbarComponent } from './report-bottom-toolbar/report-bottom-toolbar.component';
import { DoBottomToolbarComponent } from './do-bottom-toolbar/do-bottom-toolbar.component';
import { MapBottomToolbarComponent } from './map-bottom-toolbar/map-bottom-toolbar.component';
import { TrackBottomToolbarComponent } from './track-bottom-toolbar/track-bottom-toolbar.component';
import { TimelineBottomToolbarComponent } from './timeline-bottom-toolbar/timeline-bottom-toolbar.component';
import { WikiEditorBottomToolbarComponent } from './wiki-bottom-toolbar/wiki-bottom-toolbar/wiki-bottom-toolbar.component';
import { WikiTableBottomToolbarComponent } from './wiki-table-bottom-toolbar/wiki-table-bottom-toolbar.component';

@Component({
  selector: 'app-bottom-toolbar',
  templateUrl: './bottom-toolbar.component.html',
  styleUrl: './bottom-toolbar.component.scss',
  standalone: false,
})
export class BottomToolbarComponent extends BaseComponent implements OnInit {
  @ViewChild('container', { read: ViewContainerRef, static: true })
  container!: ViewContainerRef;

  constructor(private dashboardHelper: DashboardHelper) {
    super();
  }

  ngOnInit() {
    this.subscribers.currentETApplication = this.dashboardHelper.$currentApplication.subscribe((res: any) => {
      if (res) {
        const currentAppName = res.displayName.toLowerCase();
        this.loadComponent(currentAppName);
      }
    });
  }

  private loadComponent(currentAppName: string) {
    this.container.clear(); // Clear previous component

    if (currentAppName === AppConstants.CATCH_INTERNAL_APP_REPORT_LOWER) {
      this.container.createComponent(ReportBottomToolbarComponent);
    } else if (currentAppName === AppConstants.DO) {
      this.container.createComponent(DoBottomToolbarComponent);
    } else if (currentAppName === AppConstants.MAP) {
      this.container.createComponent(MapBottomToolbarComponent);
    } else if (currentAppName === AppConstants.TRACK) {
      this.container.createComponent(TrackBottomToolbarComponent);
    } else if (currentAppName === AppConstants.CATCH_INTERNAL_APP_TIMELINE_LOWER) {
      this.container.createComponent(TimelineBottomToolbarComponent);
    } else if (currentAppName === AppConstants.CATCH_INTERNAL_APP_WIKI_LOWER) {
      this.container.createComponent(WikiEditorBottomToolbarComponent);
    } else if (currentAppName === AppConstants.CATCH_INTERNAL_APP_WIKI_LOWER) {
      this.container.createComponent(WikiTableBottomToolbarComponent);
    }
  }
}
